<table class="table table-sm table-bordered" style="padding:20px">
    <tbody>
        <tr *ngFor="let key of config">
            <td>{{key.name}}</td>
            <td *ngIf="_object">
                <input class="colour-picker-button" *ngIf="key.type == 'colour'" [style.background]="_object[key.key]" [cpPosition]="'bottom'" [(colorPicker)]="_object[key.key]" 
                    (colorPickerClose)="update()" [cpPresetLabel]="'Standard'" [cpPresetColors]="app.colours"/>
                <input class="form-control form-control-sm" *ngIf="key.type == 'number'" type="number" [(ngModel)]="_object[key.key]" 
                    [placeholder]="key.name" (change)="update()" [min]="key.min" [max]="key.max" [step]="key.step"/>
            </td>
        </tr>
    </tbody>
</table>